<template>
  <div>
    <LiefengContent>
      <template v-slot:title>{{ '信息分享记录' }}</template>
      <template v-slot:toolsbarRight>
        <Form :model="searchForm" :label-colon="true" :inline="true" class="search">
          <FormItem>
            <Select
              v-model="searchForm.informationId"
              placeholder="请选择信息ID"
              clearable
              filterable
              transfer
              style="width: 200px"
            >
              <Option v-for="item in informationOptions" :key="item.id" :value="item.id">
                {{ item.title }}
              </Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select
              v-model="searchForm.orgCodeSelf"
              placeholder="请选择机构"
              clearable
              filterable
              transfer
              style="width: 200px"
            >
              <Option v-for="item in orgOptions" :key="item.orgCode" :value="item.orgCode">
                {{ item.orgName }}
              </Option>
            </Select>
          </FormItem>
          <FormItem>
            <Input
              v-model="searchForm.mobile"
              placeholder="请输入手机号"
              @on-blur="validateMobile"
              style="width: 200px"
            />
          </FormItem>
          <Button type="primary" icon="ios-search" @click="handleSearch" style="margin-right: 10px">查询</Button>
          <Button type="success" @click="handleReset" icon="ios-refresh" style="margin-right: 10px">重置</Button>
        </Form>
      </template>

      <template v-slot:contentArea>
        <LiefengTable
          :talbeColumns="columns"
          :tableData="tableData"
          :loading="loading"
          :fixTable="true"
          :curPage="pagination.current"
          :total="pagination.total"
          :pagesizeOpts="[20, 30, 50, 100]"
          :page-size="pagination.pageSize"
          @hadlePageSize="handlePageSizeChange"
        />
      </template>
    </LiefengContent>

    <!-- Action Users Modal -->
    <LiefengModal
      title="参与数据列表"
      :value="actionUsersVisible"
      @input="actionUsersVisible = $event"
      :fullscreen="false"
      height="800px"
      width="800px"
    >
      <template v-slot:contentarea>
        <Form :model="actionUsersSearchForm" :label-colon="true" :inline="true" class="search">
          <FormItem>
            <Input
              v-model="actionUsersSearchForm.mobile"
              placeholder="请输入手机号"
              @on-blur="validateActionUsersMobile"
              style="width: 200px"
            />
          </FormItem>
          <FormItem>
            <Select v-model="actionUsersSearchForm.fill" placeholder="请选择是否填报" style="width: 200px">
              <Option value="">全部</Option>
              <Option :value="0">否</Option>
              <Option :value="1">是</Option>
            </Select>
          </FormItem>
          <Button type="primary" icon="ios-search" @click="handleActionUsersSearch" style="margin-right: 10px">查询</Button>
          <Button type="success" @click="handleActionUsersReset" icon="ios-refresh" style="margin-right: 10px">重置</Button>
        </Form>

        <LiefengTable
          :talbeColumns="actionUsersColumns"
          :tableData="actionUsersData"
          :loading="actionUsersLoading"
          :fixTable="true"
          :curPage="actionUsersPagination.current"
          :total="actionUsersPagination.total"
          :pagesizeOpts="[20, 30, 50, 100]"
          :page-size="actionUsersPagination.pageSize"
          @hadlePageSize="handleActionUsersPageSizeChange"
        />
      </template>
      <template v-slot:toolsbar>
        <Button type="info" @click="actionUsersVisible = false" style="margin-right:10px">关闭</Button>
      </template>
    </LiefengModal>
  </div>
</template>

<script>
import LiefengContent from "@/components/LiefengContent3";
import LiefengTable from "@/components/LiefengTable";
import LiefengModal from "@/components/LiefengModal";

export default {
  name: 'InformationShare',
  components: {
    LiefengContent,
    LiefengTable,
    LiefengModal
  },
  data() {
    return {
      // Main table state
      searchForm: {
        columnCodeList: '',
        statusList: '4,5',
        id: '',
        orgCodeSelf: '',
        mobile: '',
      },
      loading: false,
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      tableData: [],
      informationOptions: [],
      orgOptions: [],

      // Action users modal state
      actionUsersVisible: false,
      currentShareId: '',
      actionUsersSearchForm: {
        shareId: '',
        mobile: '',
        fill: '',
      },
      actionUsersLoading: false,
      actionUsersPagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      actionUsersData: [],

      // Column definitions
      columns: [
        {
          title: '所属机构',
          key: 'orgName',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '所属栏目',
          key: 'columnName',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '分享内容',
          key: 'title',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '发布时间',
          key: 'releaseTime',
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', {}, params.row.releaseTime ? this.$core.formatDate(new Date(params.row.releaseTime), 'yyyy-MM-dd hh:mm:ss') : '');
          }
        },
        {
          title: '分享帐号',
          key: 'shareUserMobile',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '点击人数',
          key: 'actionUserCount',
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return h('a', {
              style: {
                color: '#2d8cf0',
                cursor: 'pointer'
              },
              on: {
                // click: () => params.row.shareId && this.showActionUsers(params.row),
                click: () => this.showActionUsers(params.row),
              },
            }, params.row.actionUserCount);
          }
        },
      ],
      actionUsersColumns: [
        {
          title: '点击帐号',
          key: 'actionUserMobile',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '点击时间',
          key: 'actionTime',
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', {}, params.row.actionTime ? this.$core.formatDate(new Date(params.row.actionTime), 'yyyy-MM-dd hh:mm:ss') : '');
          }
        },
        {
          title: '是否填报',
          key: 'fill',
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', {}, params.row.fill === 1 ? '是' : '否');
          }
        },
      ],
    };
  },

  mounted() {
    this.fetchInformationOptions();
    this.fetchOrgOptions();
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await this.$get('/gateway/syinfopublish/api/app/information/share/selectSharePage', {
          ...this.searchForm,
          page: this.pagination.current,
          pageSize: this.pagination.pageSize,
        });
        console.log('分页res', res);
        
        if (res.code == 200) {
          this.tableData = res.dataList || [];
          this.pagination.total = res.maxCount || 0;
        } else {
          this.$Message.error(res.message || '获取数据失败');
        }
      } catch (error) {
        console.log('报错信息', error);
        this.$Message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    async fetchInformationOptions() {
      try {
        const res = await this.$get('/gateway/syinfopublish/api/app/information/share/selectInformationList', {
          columnCodeList: this.searchForm.columnCodeList,
          statusList: this.searchForm.statusList,
        });
        console.log('信息列表res', res);
        
        if (res.code == 200) {
          this.informationOptions = res.dataList || [];
          console.log('信息列表', this.informationOptions);
        }
      } catch (error) {
        this.$Message.error('获取信息列表失败');
      }
    },

    async fetchOrgOptions() {
      try {
        const res = await this.$get('/gateway/syinfopublish/api/app/information/share/selectOrgList', {
          columnCodeList: this.searchForm.columnCodeList,
          statusList: this.searchForm.statusList,
        });
        if (res.code == 200) {
          this.orgOptions = res.dataList || [];
        }
      } catch (error) {
        this.$Message.error('获取机构列表失败');
      }
    },

    validateMobile() {
      if (this.searchForm.mobile && !/^1[3-9]\d{9}$/.test(this.searchForm.mobile)) {
        this.$Message.error('请输入正确的手机号码');
        this.searchForm.mobile = '';
      }
    },

    validateActionUsersMobile() {
      if (this.actionUsersSearchForm.mobile && !/^1[3-9]\d{9}$/.test(this.actionUsersSearchForm.mobile)) {
        this.$Message.error('请输入正确的手机号码');
        this.actionUsersSearchForm.mobile = '';
      }
    },

    handleSearch() {
      this.pagination.current = 1;
      this.fetchData();
    },

    handleReset() {
      this.searchForm = {
        ...this.searchForm,
        informationId: '',
        orgCodeSelf: '',
        mobile: '',
      };
      this.handleSearch();
    },

    handlePageChange(page) {
      this.pagination.current = page;
      this.fetchData();
    },

    handlePageSizeChange(val) {
      this.pagination.pageSize = val.pageSize;
      this.pagination.current = val.page;
      this.fetchData();
    },

    showActionUsers(record) {
      this.actionUsersSearchForm.shareId = record.shareId;
      this.actionUsersVisible = true;
      this.fetchActionUsers();
    },

    async fetchActionUsers() {
      this.actionUsersLoading = true;
      try {
        const res = await this.$get('/gateway/syinfopublish/api/app/information/share/selectShareUserPage', {
          ...this.actionUsersSearchForm,
          page: this.actionUsersPagination.current,
          pageSize: this.actionUsersPagination.pageSize,
        })
        if (res.code == 200) {
          this.actionUsersData = res.dataList || [];
          this.actionUsersPagination.total = res.maxCount || 0;
        } else {
          this.$Message.error(res.message || '获取参与数据失败');
        }
      } catch (error) {
        this.$Message.error('获取参与数据失败');
      } finally {
        this.actionUsersLoading = false;
      }
    },

    handleActionUsersSearch() {
      this.actionUsersPagination.current = 1;
      this.fetchActionUsers();
    },

    handleActionUsersReset() {
      this.actionUsersSearchForm = {
        ...this.actionUsersSearchForm,
        mobile: '',
        fill: '',
      };
      this.handleActionUsersSearch();
    },

    handleActionUsersPageChange(page) {
      this.actionUsersPagination.current = page;
      this.fetchActionUsers();
    },

    handleActionUsersPageSizeChange(val) {
      this.actionUsersPagination.pageSize = val.pageSize;
      this.actionUsersPagination.current = val.page;
      this.fetchActionUsers();
    },
  },
};
</script>

<style scoped>
.search {
  margin-bottom: 16px;
}
</style>